import DropDown from './components/Dropdown.vue'
import Expiry from './components/Expiry.vue'
import GoogleMaps from './components/GoogleMaps.vue'
import Loading from './components/Loading.vue'
import FormInput from './components/Forms/Input.vue'
import FormTextarea from './components/Forms/Textarea.vue'
import FormSelect from './components/Forms/Select.vue'
import FormDatetime from './components/Forms/Datetime.vue'
/**
 * You can register global components here and use them as a plugin in your main Vue instance
 */

const GlobalComponents = {
  install (Vue) {
	 Vue.component('drop-down', DropDown)
	 Vue.component('expiry', Expiry)
	 Vue.component('google-maps', GoogleMaps)
	 Vue.component('loading', Loading)
	 Vue.component('form-input', FormInput)
	 Vue.component('form-select', FormSelect)
	 Vue.component('form-textarea', FormTextarea)
	 Vue.component('form-datetime', FormDatetime)
  }
}

export default GlobalComponents



// WEBPACK FOOTER //
// ./src/globalComponents.js